import React from 'react';


type HeaderProps = {
    errorText: string;
}

function MainErrorText(props: HeaderProps) {

    return (
        <div className="alert alert-danger">{props.errorText}</div>
    );
}

export default MainErrorText
